import { ReactElement } from "react";
import { useDependency } from "../../../../contexts/DependencyContext";
import { useTimeMachine } from "../../../../contexts/TimeMachineContext"
import { useRecurrentAsyncCall } from "../../../../hooks/UseAsyncCall";
import { IndicatorListService } from "../../../../services/http/indicatorlist/IndicatorListService";
import { IWidget } from "../../../../services/http/widget/models/IWidget";
import { ICurrentIssuesConfiguration } from "../../../../services/http/widget/models/ICurrentIssuesConfiguration";
import { GetIndicatorsParameters } from "../../../../services/http/indicatorlist/models/GetIndicatorsParameters";
import { IIndicatorGroupResult } from "../../../../services/http/indicatorlist/models/IIndicatorGroupResult";
import NoData from "../../../../components/Shared/NoData";
import IndicatorGroup from "./IndicatorGroup";
import Spinner from "../../../../components/Shared/Spinner";
import styles from "./IndicatorList.module.scss";
import { FullScreenWidgetService } from "../../../../services/widgets/FullScreenWidgetService";
import { WidgetTypes } from "../../../../services/http/widget/models/WidgetTypes";

export interface IIndicatorList
{
    widget: IWidget;
    widgets: IWidget[];
}

async function loadData(service: IndicatorListService, componentId: number, timeMachineDate: Date): Promise<IIndicatorGroupResult[]>
{
    const parameters = new GetIndicatorsParameters();
    parameters.componentId = componentId;
    parameters.date = timeMachineDate;

    return await service.getGroupedIndicators(parameters);
}

function IndicatorList(props: IIndicatorList): ReactElement
{
    const service = useDependency(IndicatorListService);
    const widgetService = useDependency(FullScreenWidgetService);
    const timeMachine = useTimeMachine();
    const statusHistory = props.widgets.find(widget => widget.widgetType === WidgetTypes.StatusHistory);
    if (statusHistory) {
        props.widget.uiConfiguration = widgetService.updateUiConfig(props.widget.uiConfiguration as string, statusHistory.id, "statusHistoryId");
    };
    const configuration = JSON.parse(props.widget.uiConfiguration) as ICurrentIssuesConfiguration;
    let { loading, content } = useRecurrentAsyncCall(300000, loadData, service, configuration.componentId, timeMachine);
    const validGroups = content?.filter(x => x.indicators.some(y => !y.isAori));

    if (loading) return <Spinner caption="Loading indicators..." />;

    return (
        <div className={styles.wrapper}>
            {validGroups && validGroups.length > 0
                ? validGroups.map(x => <IndicatorGroup key={x.typeName} group={x} componentId={configuration.componentId} statusHistoryId={configuration.statusHistoryId} widgetId={props.widget.id} />)
                : <NoData badgeText={"No additional smart indicators configured"} message=""/>
            }
        </div>
    );
}

export default IndicatorList;